import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, resolveComponent as _resolveComponent } from "vue";
const _hoisted_1 = { class: "p-container" };
const _hoisted_2 = {
    key: 0,
    class: "text-overview"
};
const _hoisted_3 = {
    key: 1,
    class: "text-overview"
};
const _hoisted_4 = {
    key: 0,
    class: "nav nav-tabs"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = { class: "tab-content py-3" };
const _hoisted_7 = { key: 0 };
const _hoisted_8 = { key: 0 };
import ButtonComponent from '../components/Button.vue';
import EditRouteView from './editRoute.vue';
import BaseModal from '@/components/BaseModal.vue';
import 'vue-toast-notification/dist/theme-sugar.css';
import axios from 'axios';
import { ref, onMounted } from 'vue';
import version from '../../package.json';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
export default /*@__PURE__*/ _defineComponent({
    __name: 'routesView',
    props: {
        museumId: { type: String, },
        token: { type: String, },
        baseUrl: { type: String },
        router: { type: Object },
        route: { type: Object },
    },
    setup(__props) {
        const props = __props;
        const isLoading = ref(false);
        const getError = ref(null);
        const activeItem = ref('');
        const userRole = ref("visitor");
        const isGroupsetModal = ref(false);
        const isError = ref(false);
        const isUserRoleError = ref(false);
        const tabs = ref([]);
        const editRouteRef = ref(null);
        const router = ref(props.router);
        const fetchUserInfo = async () => {
            isLoading.value = true;
            try {
                const response = await axios
                    .get(`${props.baseUrl}/v1/users/me`, {
                    headers: {
                        Authorization: `Bearer ${props.token}`,
                    },
                });
                getError.value = null;
                if (response.data.roles.admin) { // TODO: orrendo, da migliorare
                    userRole.value = "admin";
                    isUserRoleError.value = false;
                }
                else if (response.data.roles.curator) {
                    userRole.value = "curator";
                    isUserRoleError.value = false;
                }
                else {
                    userRole.value = "visitor";
                    isUserRoleError.value = true;
                }
            }
            catch (error) {
                getError.value = error;
                userRole.value = null;
                isUserRoleError.value = true;
            }
            finally {
                isLoading.value = false;
            }
        };
        const fetchData = async () => {
            isLoading.value = true;
            try {
                const response = await axios.get(`${props.baseUrl}/v1/private/campaigns`, {
                    params: {
                        orderBy: 'campaignStarts',
                        orderDir: 'desc'
                    },
                    headers: {
                        Authorization: `Bearer ${props.token}`,
                    },
                });
                if (response.data.results.length > 0) {
                    tabs.value = response.data.results.filter(campaign => campaign.expired === false);
                    activeItem.value = tabs.value[0].uuid;
                }
                getError.value = null;
            }
            catch (error) {
                getError.value = error;
            }
            finally {
                isLoading.value = false;
            }
        };
        const isActive = menuItem => {
            return activeItem.value === menuItem;
        };
        const setActive = menuItem => {
            activeItem.value = menuItem;
        };
        const warningGoback = () => {
            router.value.go(-1);
        };
        onMounted(() => {
            console.log('Loading @laculturapremia v', version);
            fetchData();
            fetchUserInfo();
        });
        return (_ctx, _cache) => {
            const _component_widget_container_modal = _resolveComponent("widget-container-modal");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "d-flex flex-col w-100 mb-5" }, [
                        _createElementVNode("div", { class: "d-flex flex-row w-100" }, [
                            _createElementVNode("h1", { class: "text-title" }, "Premialità")
                        ])
                    ], -1)),
                    _createElementVNode("div", null, [
                        (isLoading.value)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
                                _createVNode(_unref(Loading), {
                                    active: isLoading.value,
                                    "onUpdate:active": _cache[0] || (_cache[0] = ($event) => ((isLoading).value = $event)),
                                    "can-cancel": false,
                                    "is-full-page": true,
                                    color: "#2D489D",
                                    loader: "dots"
                                }, null, 8, ["active"])
                            ]))
                            : (getError.value || !(tabs.value.length > 0))
                                ? (_openBlock(), _createElementBlock("p", _hoisted_3, "No data to display"))
                                : _createCommentVNode("", true)
                    ]),
                    (tabs.value.length > 0)
                        ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab) => {
                                return (_openBlock(), _createElementBlock("li", {
                                    key: tab.uuid,
                                    class: "nav-item nav-title"
                                }, [
                                    _createElementVNode("a", {
                                        class: _normalizeClass(["nav-link", { active: isActive(tab.uuid) }]),
                                        onClick: _withModifiers(($event) => (setActive(tab.uuid)), ["prevent"]),
                                        href: "#"
                                    }, _toDisplayString(tab.name), 11, _hoisted_5)
                                ]));
                            }), 128))
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_6, [
                        (activeItem.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                (activeItem.value !== 'inevidence')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                        (activeItem.value !== 'inevidence')
                                            ? (_openBlock(), _createBlock(EditRouteView, {
                                                key: 0,
                                                ref_key: "editRouteRef",
                                                ref: editRouteRef,
                                                museumId: props.museumId,
                                                baseUrl: props.baseUrl,
                                                router: router.value.value,
                                                campaignId: activeItem.value
                                            }, null, 8, ["museumId", "baseUrl", "router", "campaignId"]))
                                            : _createCommentVNode("", true)
                                    ]))
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ]),
                _createVNode(BaseModal, {
                    isOpen: isUserRoleError.value || isGroupsetModal.value,
                    name: "warning-modal"
                }, {
                    header: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                            _createElementVNode("h1", { class: "font-display-4" }, " Avvertimento! ", -1)
                        ]))]),
                    content: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                            _createElementVNode("h5", null, "Per poter accedere alla sezione 'Premialità' è necessario essere profilati come 'Responsabile del raggruppamento' o 'supporto al responsabile' nella piattaforma del Sistema museale nazionale.", -1)
                        ]))]),
                    footer: _withCtx(() => [
                        _createVNode(ButtonComponent, {
                            text: "Indietro",
                            type: "regular",
                            class: "bg-white",
                            isDisable: false,
                            onHandleClick: warningGoback
                        })
                    ]),
                    _: 1
                }, 8, ["isOpen"]),
                _createVNode(BaseModal, {
                    isOpen: isError.value && !isUserRoleError.value,
                    onModalClose: () => '',
                    name: "warning-modal"
                }, {
                    header: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                            _createElementVNode("h3", null, " Avvertimento! ", -1)
                        ]))]),
                    content: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                            _createElementVNode("h5", null, "Errore caricamento Premialità.", -1)
                        ]))]),
                    footer: _withCtx(() => [
                        _createVNode(ButtonComponent, {
                            text: "Indietro",
                            type: "regular",
                            class: "bg-white",
                            isDisable: false,
                            onHandleClick: warningGoback
                        })
                    ]),
                    _: 1
                }, 8, ["isOpen"]),
                _createVNode(_component_widget_container_modal)
            ], 64));
        };
    }
});
